import React from "react";

import { Tag } from "@chakra-ui/react";

export default function SupplierCategoryTags(props) {
  const category_name = props.category_name;

  return (
    <Tag
      size="sm"
      key="sm"
      variant="solid"
      background={"#17BAB326"}
      textColor={"#0E716D"}
      borderRadius={"0.25rem"}
    >
      {category_name}
    </Tag>
  );
}
